export const FilterActionTypes = {
  SET_FILTER: "SET_FILTER",
  SET_ACTIVE_FILTER: "SET_ACTIVE_FILTER",
  RESET: "RESET",
  SET_TAGS_OPERATOR: "SET_TAGS_OPERATOR",
  SET_WITHOUT_TAGS_OPERATOR: "SET_WITHOUT_TAGS_OPERATOR",
};
